import { DEFAULT_PAGE_SIZE } from '@/components';
import { calculateProjectFiscalYear } from '@/utils';
import { fundSheetTypeEnum, sheetTypeEnum } from '@/utils/enum';
import {
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

export const useInspectionSearchQueryStates = () => {
  const [searchQueryStates, setSearchQueryStates] = useQueryStates({
    fiscalYear: parseAsString.withDefault(
      calculateProjectFiscalYear().toString(),
    ),
    sheetType: parseAsStringLiteral(sheetTypeEnum.options).withDefault(
      sheetTypeEnum.enum.RS,
    ),
    fundSheetType: parseAsStringLiteral(fundSheetTypeEnum.options),
    cascader: parseAsString,
    page: parseAsInteger.withDefault(1),
    pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
  });
  return { searchQueryStates, setSearchQueryStates };
};
